export enum SearchTab {
    Regions,
    Places,
    Offers,
    Vendors,
    Holiday
}
export enum SearchTab {
    Regions,
    Places,
    Offers,
    Vendors,
    Holiday
}
